import type { AladdinDataPackages } from '@blk/aw-bff-typescript-models';
import { getQueryClient } from '../../queryClient';
import { clientConfigurationsQuery } from '../queries';

/**
 * Fetch available package configurations with TanStack Query caching.
 */
export function getClientConfigurationList(): Promise<AladdinDataPackages[]> {
  const queryClient = getQueryClient();

  return queryClient.fetchQuery(clientConfigurationsQuery);
}
